import { apiClient } from '@/shared/api/http-client';

import type {
    ChangeFeeInput,
    ChangeFeeOutput,
    ClientBalance,
    GetSessionChargeListOutput,
    GetUnpaidSessionChargeListOutput,
    SessionChargeListFilters,
} from '../model/session-charge.types';

export const sessionChargeApi = {
    changeFee: async (
        id: string,
        data: ChangeFeeInput,
        signal?: AbortSignal,
    ): Promise<ChangeFeeOutput> => {
        return apiClient.post(`/session-charge/${id}/change-fee`, data, signal);
    },

    getList: async (
        filters: SessionChargeListFilters,
        signal?: AbortSignal,
    ): Promise<GetSessionChargeListOutput> => {
        const params = new URLSearchParams({ clientId: filters.clientId });

        if (filters.pageSize) params.set('pageSize', filters.pageSize.toString());
        if (filters.cursor) params.set('cursor', filters.cursor);

        return apiClient.get(`/session-charge/list?${params.toString()}`, signal);
    },

    getBalance: async (clientId: string, signal?: AbortSignal): Promise<ClientBalance> => {
        const params = new URLSearchParams({ clientId });

        return apiClient.get(`/session-charge/balance?${params.toString()}`, signal);
    },

    getUnpaidList: async (
        clientId: string,
        signal?: AbortSignal,
    ): Promise<GetUnpaidSessionChargeListOutput> => {
        const params = new URLSearchParams({ clientId });

        return apiClient.get(`/session-charge/unpaid?${params.toString()}`, signal);
    },
};
